module.exports = __webpack_public_path__ + "img/polish.b4ac3d3.webp";